export const SWR_OPTIONS = {
	errorRetryCount: 1,
	revalidateOnFocus: false,
}
